import React from "react";
import BlogSection from "../LandingPage/BlogSection/Main";
import TopSection from "./TopSection/Main";

const Blog = () => {
  return (
    <>
      <TopSection />
      <BlogSection />
    </>
  );
};

export default Blog;
